import { userData } from "@signals"
import { TOUR_TRANSLATIONS } from "../translations"

export const getMarketAnalyzerSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]
    const userUseRRSP = userData.value.useRRSP != null ? userData.value.useRRSP : 1

    const steps = [
        {
            target: '[data-tour="market-analyzer-filters"]',
            title: t.marketAnalyzerFilters.title,
            content: t.marketAnalyzerFilters.content,
            disableBeacon: true,
        },
        !!userUseRRSP && {
            target: '[data-tour="market-analyzer-share-chart"]',
            title: t.marketAnalyzerShareChart.title,
            content: t.marketAnalyzerShareChart.content,
        },
        {
            target: '[data-tour="market-analyzer-table"]',
            title: t.marketAnalyzerTable.title,
            content: t.marketAnalyzerTable.content,
        },
        {
            target: '[data-tour="market-analyzer-create-report"]',
            title: t.marketAnalyzerCreateReport.title,
            content: t.marketAnalyzerCreateReport.content,
        },
        {
            target: '.MuiDialog-paper, .MuiDrawer-paper',
            title: t.marketAnalyzerEvolution.title,
            content: t.marketAnalyzerEvolution.content,
            placement: 'center',
            disableScrolling: true,
            data: { triggerClick: 'market-analyzer-table', closeOnLeave: true },
        },
    ]

    return steps.filter(Boolean)
}
